module.exports = __webpack_public_path__ + "img/60m7.6ea164d4.jpg";